module.exports = __webpack_public_path__ + "img/anuncio1.1675492f.png";